import { render } from "./ProductCategory.vue?vue&type=template&id=1b02cc1f&ts=true"
import script from "./ProductCategory.vue?vue&type=script&lang=ts"
export * from "./ProductCategory.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__